'use strict';

import dot from "dot";
import { initCarousel } from "../../../_scripts/helpers";

export default class FilmGalleryBanner {
  constructor($selector, selfInit = true, config) {
    this.$selector = $selector;
    this.breakpoints = config.breakpoints;
    this.$viewMoreTemplate = $("#viewMoreTemplate").html();
    this.$gallery = $(".film-gallery-banner__gallery", this.$selector);
    this.$galleryCarousel = null;
    this.$carouselPagination = $('.carousel-pagination');
    
    this.carouselOptions = {
      arrows: true,
      dots: false,
      infinite: true,
      autoplay: false,
      slidesToShow: 1,
      slidesToScroll: 1,
    }

    if (this.$gallery.length) {
      if(selfInit) this.init($selector);
    }
  }

  init($selector) {
    let resizeTimer;
    $(window).on('resize', () => {
      clearTimeout(resizeTimer);

      resizeTimer = setTimeout(() => {
        this.appendViewMore();
      }, 300);
    });

    this.appendViewMore();
    this.populateGalleryCarousel();
    this.initGalleryCarousel();
  }

  appendViewMore() {
    let dotTemplate = dot.template(this.$viewMoreTemplate)("");

    //Remove existing view more element
    this.$gallery.find('.view-more').remove();

    //Get element to append
    if ($(window).width() >= this.breakpoints.desktop) {
      //Append to the 5th element if present
      if ($('.film-gallery-banner__item', this.$gallery).length > 4) {
        $('.film-gallery-banner__item', this.$gallery).eq(4).append(dotTemplate);
        $('.film-gallery-banner__item', this.$gallery).eq(4).addClass('view-more-card');
      }
    } else {
      //Append to the 5th element if present
      if ($('.film-gallery-banner__item', this.$gallery).length > 3) {
        $('.film-gallery-banner__item', this.$gallery).eq(3).append(dotTemplate);
        $('.film-gallery-banner__item', this.$gallery).eq(3).addClass('view-more-card');
      }
    }
  }

  populateGalleryCarousel() {
    var $modal = $('.film-gallery-banner__modal .film-gallery-banner__carousel', this.$selector);
  
    // Check if the modal is empty before appending
    let mediaElements = $('.film-gallery-banner__item').clone().removeAttr('data-modal-toggle');
    $modal.html(mediaElements);

    const totalGalleryItem = mediaElements.length;
    $('.total', this.$carouselPagination).html(totalGalleryItem);
  }

  initGalleryCarousel() {
    $("body > [data-modal]").on("click", () => {
      this.destroyGalleryCarousel();
    });

    
    $("[data-modal-toggle]").map((_, ele) => {
      $(ele).on("click", (e) => {
        const index = $(ele).data("index");
         if ((typeof index !== 'undefined')) {
          this.carouselOptions.initialSlide = index;
        } 
        this.$galleryCarousel = initCarousel($('.film-gallery-banner__carousel', "[data-modal]"), this.carouselOptions, true, 
        (event, slick, currentSlide) => {
          //slick init
          $('.carousel-pagination .current', "[data-modal]").html(index+1);

          const cur = $(slick.$slides[slick.currentSlide]);
          //$('.carousel-pagination .mediaTtype', "[data-modal]").html();
        }, 
        (event, slick, currentSlide, nextSlide) =>{
          //slick before
          $('.carousel-pagination .current', "[data-modal]").html(nextSlide+1);
        });
      });
    });
  }

  destroyGalleryCarousel() {
    $('.film-gallery-banner__carousel', "[data-modal]").hide();
    this.$galleryCarousel.unslick();
  }
}
